<template>
    <multi-select :value="value"  label="name" :multiple="false" :options="countries" :loading="loading" :searchable="true" track-by="id"
                  :placeholder="this.$t('SEARCH')"
                  :select-label="this.$t('APPLY')"
                  @search-change="search"
                  @input="onSelect"
                >
    </multi-select>
</template>

<script>

import MultiSelect from 'vue-multiselect'
import _debounce from 'lodash/debounce'
import {getCountriesList} from '@/services/recognition/index'

    export default {
      name: "Country",
      data(){
          return{
            countries:[],
            selected:null,
            loading:false,

          }
      },
      props:{
          value: {
              type:Object,
              default: function () {
                  return {
                      id: null,
                      name:null
                  }
              }
          }
      },
      computed:{
        language(){
          return localStorage.getItem('language') ? localStorage.getItem('language') : 'hr'
        }
      },

      methods:{
            search:_debounce(function(value){
              if(value === ""){
                return
              }
              this.loading = true
                getCountriesList({name:value})
                .then(response =>{
                    this.countries = response.data

                }).finally(()=>{
                  this.loading = false
                })
            }, 600),
            onSelect(value){
             if(value === null){
               this.$emit("input", {id:null, name:null})
             }else{
             this.$emit("input", value)
             }

            }
      },
      components:{
        MultiSelect
      },
      created(){
          if(this.value !== null && this.value.id !== null){
            this.countries.push(this.value)
          }
      }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .multiselect__tags {
    min-height: 35px !important;
    display: block;
    padding: 0px 37px 0 7px !important;
    border-radius: 5px;
    border: 1px solid #e8e8e8;
    background: #fff;
    font-size: 14px;
  }
  .multiselect__single {
    font-size: 14px;
    padding-top: 5px;
    margin-bottom: unset;

  }
  .multiselect, .multiselect__input {
    min-height: 13px;
    line-height: 16px;
  }
</style>
